const BASE_URL= `/Eventbadgemanagement`

export const generateView = async (client) => {
   // console.log(token)
    try {
        const res = await fetch(`${BASE_URL}/GenerateViewTrigger`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(client),
        })
        return await console.log("Status Code: ", res.status)
    } catch (error) {
        throw error
    }
}
export const generateGuestView = async (client) => {
    // console.log(token)
    try {
        const res = await fetch(`${BASE_URL}/GenerateGuestViewTrigger`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(client),
        })
        return await console.log("Status Code: ", res.status)
    } catch (error) {
        throw error
    }
}

export const generateObjectsList = async (client) => {
    //console.log(token)
    try {
        const res = await fetch(`${BASE_URL}/GenerateObjectsList`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(client),
        })
        return await console.log("Status Code: ", res.status)
    } catch (error) {
        throw error
    }
}

export const clearViewFilters = async clientEvent => {
    try {
        //console.log('clientevent: ' + JSON.stringify(clientEvent));
        const res = await fetch(`${BASE_URL}/ClearViewFiltering`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(clientEvent),
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const clearGuestViewFilters = async clientEvent => {
    try {
        //console.log('clientevent: ' + JSON.stringify(clientEvent));
        const res = await fetch(`${BASE_URL}/ClearGuestViewFiltering`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(clientEvent),
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const saveEventField = async EventField => {
    try {
        const res = await fetch(`${BASE_URL}/AddFilterItem`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(EventField),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getView = async body => {
    try {
        const res = await fetch(`${BASE_URL}/GetClientEventRegistrant`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const getGuestRegistrant = async body => {
    try {
        const res = await fetch(`${BASE_URL}/GetClientEventGuestRegistrant`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getViewDetails = async body => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveViewDetails`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getGuestViewDetails = async body => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveGuestViewDetails`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        })
        if ( res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getEventFilteringOptions = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventFilteringOption`, {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const loadEventFilters = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventRegistrantObjects`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(event),
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const loadEventGuestFilters = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventGuestRegistrantObjects`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(event),
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const loadEventObjects = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventObjects`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(event),
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const saveEventFilter = async (EventFilter) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveEventFilterObject`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(EventFilter)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const deleteEvenFilterObject = async (Id) => {
    try {
        const res = await fetch(`${BASE_URL}/ClearItem`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(Id)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const saveBadgeTemplateFieldSelections = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveEBtoERSFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        return await res
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const saveGuestBadgeTemplateFieldSelections = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveEBGtoERSFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        return await res
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const saveExtraBadgeTemplateFieldSelections = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveEEBtoERSFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        return await res
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getRegTypesForMapping = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveRegistratonTypeMapping`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const saveRegistrationTypeMappings = async (regTypeMappings) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveRegistrationTypeMappings`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(regTypeMappings)
        })
        return await res
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getRegFieldsOrdering = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveRegistratonFieldsOrdering`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const getGuestFieldsOrdering = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveGuestFieldsOrdering`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const saveRegFieldsOrdering = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveRegistrationFieldsOrdering`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        //return await res.json()
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const saveGuestFieldsOrdering = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveGuestFieldsOrdering`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        //return await res.json()
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getExtraBadgeFieldsOrdering = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadgeFieldOrdering`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const saveExtraBadgesFieldsOrdering = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveExtraBadgesFieldsOrdering`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }

    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getExtraBadgesStaticFields = async (fields) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadgeStaticFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fields)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const saveExtraBadgesStaticFields = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveExtraBadgeStaticFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        //return await res.json()
        if (res.status === 200 || res.status === 204) {
            return await "Success"
        }
        else {
            return await "error"
        }

    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getQrCodeThirdPartyFormula= async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveThirdPartyFormulaOptions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getQrCodeChoices = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveQrCodeChoices`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getScannerImageSetup = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveScannerImageSetup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const getGuestSetup = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveGuestSetup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const getViewFields = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveViewFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const getGuestViewFields = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveGuestViewFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getAdminPrintSelections = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAdminPrintSelections`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const getAdminPrintFlatSelections = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAdminPrintFlatSelections`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const saveScannerImageSetup = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveScannerImageSetup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const saveGuestSetup = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveGuestSetup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const saveBadgeImages= async (images) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveImageFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(images)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const clearBadgeImages = async (body) => {
    try {
        const res = await fetch(`${BASE_URL}/ClearImageFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getImageFields = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveImageFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(event)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getImageTest = async () => {
    try {
        const res = await fetch(`${BASE_URL}/GenerateImage`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getSavedTemplates = async () => {
    //const token = tokenService.getToken()
    //try {
    //    const res = await fetch(`${BASE_URL}/RetrieveEventRegistrantObjects`, {
    //        method: 'POST',
    //        headers: {
    //            'Content-Type': 'application/json',
    //            'Authorization': `Bearer ${token}`
    //        },
    //        body: JSON.stringify(client),
    //    })
    //    return await res.json()
    //} catch (error) {
    //    console.log(error)
    //    throw error
    //}

    return []
}

export const getEventBadgeFields = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventBadgeFieldOptions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getEventBadgeFieldsWithSelected = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventBadgeFieldOptionsWithSelected`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(event)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getEventGuestBadgeFieldsWithSelected = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventGuestBadgeFieldOptionsWithSelected`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(event)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getSavedFieldSelections = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventBadgeFieldOptions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(event)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getEventExtraBadgeFieldOptionsWithRanking = async (fields) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventExtraBadgeFieldsOptionsWithRanking`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fields)
        })
        /*return await res.json()*/

        // Read the response as text
        const responseText = await res.text()

        return responseText
    } catch (error) {
        throw error
    }
}
export const getEventGuestBadgeFieldOptionsWithRanking = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventGuestBadgeFieldOptionsWithRanking`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(event)
        })
        return await res.json()
    } catch (error) {
        throw error

    }
}

export const getExtraBadgeFieldWithSelections = async (fields) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadgeFieldsWithSelections`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fields)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const saveExtraBadgeFields = async (fields) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveExtraBadgesFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fields)
        })
        //return await res.json()
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        throw error
    }
}

export const getKioskSetup = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveKioskSetup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const saveKioskSetup = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveKioskSetup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        return await res.json()

    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getFlatTemplateSetup = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveFlatTemplateSetup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const retrieveFlatTemplate = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveFlatTemplate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
    } catch (error) {
        console.log(error)
        throw error
    }
}


export const saveFlatTemplateSetup = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveFlatTemplateSetup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        if (res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }

    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getKioskEditScreenSetup = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveKioskEditScreenLayout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getKioskEditScreenSetupWithLayout = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveKioskEditScreenSetupWithLayout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const saveKioskEditScreenSetup = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveKioskFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }

    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getKioskLayoutOptions = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveKioskLayoutOptions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const getEventBadgeFieldOptionsWithRanking = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventBadgeFieldOptionsWithRanking`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(event)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getExtraBadgesTemplates = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadges`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(event)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getBadgeTemplate = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveBadgeTemplate`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(event)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}


export const getMainTemplate = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveMainTemplate`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(event)
        })
        //return await res.json()
        if (res.status === 204 || res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
    } catch (error) {
        throw error
    }
}

export const getGuestTemplate = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveGuestTemplate`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(event)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getExtraBadgeTemplates = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadgesTemplates`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(event)
        })
        if (res.status === 204 || res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
        
    } catch (error) {
        throw error
    }
}

export const getExtraBadgeTemplateConditions = async (event) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExtraBadgeTemplateConditions`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(event)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const saveMainTemplate = async (templateInfo) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveMainTemplate`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(templateInfo)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const saveGuestTemplate = async (templateInfo) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveGuestTemplate`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(templateInfo)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const saveExtraBadgesTemplate = async (templateInfo) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveExtraBadgesTemplate`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(templateInfo)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const retrieveAttendanceReport = async (regHeader) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAttendanceReport`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(regHeader)
        })
        if (res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
    } catch (error) {
        throw error
    }
}

export const retrieveAdHocAttendanceReport = async (regHeader) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAdHocAttendanceReport`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(regHeader)
        })
        if ( res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
    } catch (error) {
        throw error
    }
}

export const saveScannerPageSetup = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveScannerPageSetup`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        return await res.json()

    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getScannerPageSetup = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveScannerPageSetup`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getLandingPageSetup = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveLandingPageSetup`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}


export const saveLandingPageSetup = async (fieldSelections) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveLandingPageSetup`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(fieldSelections)
        })
        return await res.json()

    } catch (error) {
        console.log(error)
        throw error
    }
} 

export const getSnapshotMonitors = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveSnapshotMonitorsEvents`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const getFlatSetupCheck = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/CheckFlatSetup`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}